// ©2024 Austin App House. All rights reserved.
import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { toggleModal } from '../../../storage/actions/modalsActions';
import SelectMessageRecipients from './SelectMessageRecipients';
import NewMessage from '../workOrderMessageSystemModal/NewMessage';
import { selectWorkOrder } from '../../../storage/actions/applicationStateActions';
// eslint-disable-next-line import/no-cycle
import { SocketContext } from '../../../pages';

const BulkMessage = ({
  modalState,
  toggleModal,
  auth,
  selectedWorkOrders,
  selectWorkOrder,
  activeTab,
}) => {
  const [companyUsers, fetchCompanyUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isForContractor, setIsNeedSendToContractor] = useState(false);

  const { chatSocket: socket } = useContext(SocketContext) ?? {};

  useEffect(() => {
    if (!modalState?.isOpen) {
      return undefined;
    }

    let active = true;
    axios.get('/api/users/get-clients').then((res) => {
      if (!active) return;
      fetchCompanyUsers(
        res.data.clients
          .filter((el) => el.userId)
          .map((el) => ({ value: el.userId, label: el.name })),
      );
    });

    return () => {
      active = false;
    };
  }, [modalState?.isOpen]);

  const closeModal = () => {
    selectWorkOrder([]);
    toggleModal(false, 'bulkMessageModal', true);
  };

  const sendMessage = (message, parentId) => {
    const workOrders = modalState.type.mode !== 'useIds'
      ? modalState.type.workOrders.map((i) => i._id)
      : selectedWorkOrders;
    socket.emit('chat', {
      parentId,
      message,
      selectedAllApplicants: true,
      workOrderId: workOrders,
      users: selectedUsers.map((el) => el.value),
      isForContractor,
      activeTab,
    });
    closeModal();
  };

  if (!modalState?.isOpen) {
    return null;
  }

  const subtitle = activeTab === 'assigned' || activeTab === 'completed'
    ? "Assigned Contractor's"
    : "Applied/Routed Contractor's";

  return (
    <div
      className="modal_block dashboard-modal dashboard-modal--centered modal_messages showed"
      role="presentation"
      onClick={closeModal}
    >
      <div
        className="modal_container"
        role="dialog"
        aria-modal="true"
        aria-labelledby="bulk-message-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal_head">
          <div className="modal_title" id="bulk-message-title">
            Send Message To
          </div>
          <div className="modal_subtitle">{subtitle}</div>
          <button
            type="button"
            className="close_btn icon_close"
            aria-label="close"
            onClick={closeModal}
          />
        </div>
        <div className="modal_body wurqly-modal-scroll">
          {auth.user.userType !== 'contractor' && (
            <SelectMessageRecipients
              companyMembers={companyUsers}
              activeTab={activeTab}
              selectedUsers={selectedUsers}
              setSelectedUsers={setSelectedUsers}
              isForContractor={isForContractor}
              setIsNeedSendToContractor={setIsNeedSendToContractor}
            />
          )}
          <NewMessage sendMessage={sendMessage} />
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
  selectWorkOrder,
};

const mapStateToProps = (state) => ({
  currentWorkOrder: state.workOrder.currentWorkOrder,
  selectedWorkOrders: state.applicationState.selectedWorkOrders,
  auth: state.auth,
  activeTab: state.applicationState.activeTab,
  modalState: state.modalState.bulkMessageModal,
  applicantsLoaded: state.workOrder.applicantsLoaded,
  routedApplicantsLoaded: state.workOrder.routedApplicantsLoaded,
  applicants: state.workOrder.applicants,
  routedApplicants: state.workOrder.routedApplicants,
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkMessage);
